import React from 'react';
import { getImageSize } from 'utils/general';

import DocumentIcon from '~/images/shared/Document.svg';

// TODO: add file type, as image, file, ex..
const FileMessage: React.FC<{ file: File }> = ({ file }) => {
  return (
    <div className='flex gap-16 rounded-xl border-sm border-neutralVariant-90 px-14 py-9 ltr:rounded-tr-[0px] rtl:rounded-tl-[0px]'>
      <div className='flex h-[28px] w-[28px] items-center justify-center rounded-full bg-surface-20 text-primary-default'>
        <DocumentIcon />
      </div>
      <div className='flex flex-col gap-1 text-14'>
        <span className='text-text-default'>{file.name}</span>
        <span className='text-surface-10'>{getImageSize(file.size)}</span>
      </div>
    </div>
  );
};

export { FileMessage };
